import React from 'react';
import {connect} from 'react-redux';
import {modal} from 'react-redux-modal';
import SocialLogin from '../../SocialLogin';
import SignUpForm from '../../Forms/SignUp';
import ConfirmInfoFormView from '../../Forms/ConfirmInfo';
import { authLogout } from '../../../actions/auth';
import LoginModal from '../Login';
import './styles.scss';
import { modalViewGA } from '../../../utils/googleAnalytics';
import TrackedButton from '../../Buttons/TrackedButton';

class SignUpComponent extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.logIn = this.logIn.bind(this);
    this.emailSignup = this.emailSignup.bind(this);
    this.state = { emailSignup: false };
    this.renderSocialsPage = this.renderSocialsPage.bind(this);
    this.renderEmailSignupPage = this.renderEmailSignupPage.bind(this);
    this.renderConfirmInfoPage = this.renderConfirmInfoPage.bind(this);
  }

  closeModal(e) {
    e.preventDefault();
    this.props.removeModal();
    if (!this.props.janrain) {
      this.props.dispatch(authLogout());
    }
  }

  logIn(e) {
    e.preventDefault();
    this.closeModal(e);
    modal.add(LoginModal, { title: '', size: 'medium', hideTitleBar: true });
  }

  componentDidMount() {
    modalViewGA('signup');
  }

  emailSignup() {
    this.setState({ emailSignup: true });
  }

  renderSocialsPage() {
    const { janrain } = this.props;
    const closeAction = (!janrain) ? (
      <a href="#" className="u-textSize-18" onClick={this.logIn}>
        <span>Already a member? Click to sign in to explore</span><span className="arw"></span>
      </a>) : null;

    return (
      <div className="modals-popup signup-modal u-font-foundation-roman">
        <div className="modal-header d-flex align-items-center">
          <div className="col">explore.org - never stop learning</div>
          <div className="text-right">
            <a className="closer" href="#" onClick={this.closeModal}></a>
          </div>
        </div>
        <div className="info">
          <div className="text-justify intro-text">
            <img className="signup-portrait float-right" src="https://media.explore.org/posters/mike-fitz-1555426715299-0.jpg" width="132" />
            <p>Hi, this is Mike, resident naturalist at explore.org,
            the world’s largest live nature cam network. Explore.org is
            100 percent philanthropic and our mission is to inspire
            life-long learning and champion the selfless acts of others.</p>
            <p>I  invite you to follow the journey by subscribing to our
            newsletter, where you’ll receive live cam updates and
            notifications about events with resource experts. Through
            our snapshot feature, you can also capture and share
            unforgettable live cam moments.</p>
            <p>Welcome to the community,<br />Mike Fitz</p>
          </div>
          <div className="d-flex flex-wrap flex-column buttons-wrap">
            <div className="signup-options">Join using social or your e-mail</div>
            <div className="social-buttons"><SocialLogin className="social-buttons-inner-wrap"/></div>
            <div className="email-button">
              <TrackedButton
                className="btn btn-primary u-textSize-18"
                onClick={ this.emailSignup }
                title="Email"
                action="Click on Email in Join modal"
              />
            </div>
          </div>
        </div>
        <div className="modal-footer">
            <span className="other-action">
              {closeAction}
            </span>
        </div>
      </div>
    )
  }

  renderConfirmInfoPage() {
    const { janrain, removeModal } = this.props;
    return (
      <div className="modals-popup signup-modal u-font-foundation-roman">
        <div className="modal-header d-flex">
          <div className="col">Confirm Account Explore Information</div>
          <div className="text-right">
            <a className="closer" href="#" onClick={this.closeModal}></a>
          </div>
        </div>
        <div className="info">
          <ConfirmInfoFormView removeModal={removeModal} />
        </div>
      </div>
    );
  }

  renderEmailSignupPage() {
    const { removeModal } = this.props;
    return (
      <div className="modals-popup signup-modal-email u-font-foundation-roman">
      <div className="modal-header d-flex">
        <div className="col">Join Explore using your e-mail</div>
        <div className="text-right">
          <a className="closer" href="#" onClick={this.closeModal}></a>
        </div>
      </div>
      <div className="info">
        <SignUpForm initialValues={{newsletter:true, tracking_consent: true}} removeModal={removeModal} />
      </div>
    </div>
    );
  }

  render() {
    const { janrain } = this.props
    const { emailSignup } = this.state;
    let modalContent = null;
    if (emailSignup) {
      modalContent = this.renderEmailSignupPage();
    } else if (janrain) {
      modalContent = this.renderConfirmInfoPage();
    } else {
      modalContent = this.renderSocialsPage();
    }
    return (
      <div>
        { modalContent }
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    janrain: state.auth.janrain,
    provider: state.auth.provider,
  };
}
export default connect(mapStateToProps)(SignUpComponent);
